import * as React from 'react';

import { Card, CardProps } from '@mui/material';

import { theme } from '@itp/talent/theme';

export type ActionContainerProps = {
  children?: React.ReactNode;
} & CardProps;

export const ActionContainer: React.FC<ActionContainerProps> = ({ children, ...props }) => {
  return (
    <Card
      {...props}
      sx={{
        alignSelf: 'flex-start',
        boxShadow: 'none',
        flexShrink: 0,
        width: { md: '30%', xs: '100%' },
        ...props?.sx,
      }}
    >
      {children}
    </Card>
  );
};
